import clsx from "clsx";
import { SubmitButton } from "@/components/utils/SubmitButton";
import { AllPostsPaginationPropTypes } from "./propTypes";
import "./styles.scss";

const AllPostsPagination = ({ changePage, page, pages }) => {
  const formatPage = (value) => {
    return value <= 9 ? "0" + value : value;
  };

  const getListItem = (pageNumber) => {
    return (
      <li key={pageNumber}>
        <SubmitButton
          className={clsx("pagination", {
            active: page == pageNumber,
          })}
          name={`${formatPage(pageNumber)}`}
          action={() => changePage(pageNumber)}
          isDisabled={pageNumber == page}
        />
      </li>
    );
  };

  const getPagination = () => {
    const pagination = [];
    const currentPage = page;
    const totalPages = pages;
    let containsLastPage = false;

    if (totalPages <= 3) {
      containsLastPage = true;

      for (let i = 1; i <= totalPages; i++) {
        pagination.push(getListItem(i));
      }
    } else {
      if (currentPage <= 2) {
        for (let i = 1; i <= 3; i++) {
          pagination.push(getListItem(i));

          if (i == pages) containsLastPage = true;
        }
      } else if (currentPage >= totalPages - 1) {
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pagination.push(getListItem(i));

          if (i == pages) containsLastPage = true;
        }
      } else {
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pagination.push(getListItem(i));

          if (i == pages) containsLastPage = true;
        }
      }
    }

    // Dots
    if (pages > 3 && !containsLastPage) {
      pagination.push(
        <li key="dots">
          <span className="text-darkGray inline-block">...</span>
        </li>
      );
    }

    // Last page
    if (!containsLastPage) {
      pagination.push(
        <li key="lastPage">
          <SubmitButton
            action={() => changePage(pages)}
            className={"pagination"}
            name={`${formatPage(pages)}`}
          />
        </li>
      );
    }

    return pagination;
  };

  return (
    <>
      {pages > 1 && (
        <ul className="posts-pagination">
          {page !== 1 && (
            <li key="first">
              <SubmitButton
                action={() => changePage(page - 1)}
                className="pagination arrow"
                name="Prev"
                Icon={() => (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.6665 5.99984L1.33317 5.99984M1.33317 5.99984L5.99984 10.6665M1.33317 5.99984L5.99984 1.33317"
                      stroke="#C5C5C5"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
                iconPosition="left"
              />
            </li>
          )}

          {getPagination()}

          {page !== pages && (
            <li key="last">
              <SubmitButton
                action={() => changePage(page + 1)}
                className="pagination arrow"
                name="Next"
                Icon={() => (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.3335 6.00016H10.6668M10.6668 6.00016L6.00016 1.3335M10.6668 6.00016L6.00016 10.6668"
                      stroke="#C5C5C5"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              />
            </li>
          )}
        </ul>
      )}
    </>
  );
};

AllPostsPagination.propTypes = AllPostsPaginationPropTypes;

export default AllPostsPagination;
